import React from "react";
import { useDispatch } from "react-redux";
import { UPDATE_VARIABLE_TSL } from "../../../../actions/create-bot-type";
import { Button } from "react-bootstrap";
import { isLong } from "../../../../utils/Utils";

const VariableTSL = (props) => {
  const { newBot } = props;
  const tsl = newBot.variableTSL;
  const long  = isLong(newBot.strategy)
  const dispatch = useDispatch();
  const updateTSL = (list) => {
    dispatch({
      type: UPDATE_VARIABLE_TSL,
      payload: list,
    });
  };

  const addVariabletSL = () => {
    updateTSL([...tsl, { triggerAt: 2, stopAt: 1 }]);
  };
  const tslItems = tsl.map((item, id) => {
    const changeStopAt = (val) => {
      const tempTsl = [...tsl];
      const trailing = tempTsl[id];
      trailing.stopAt = val;
      updateTSL(tempTsl);
    };

    const changeTriggerAt = (val) => {
      const tempTsl = [...tsl];
      const trailing = tempTsl[id];
      trailing.triggerAt = val;
      updateTSL(tempTsl);
    };

    const deleteTSL = () => {
      updateTSL(tsl.filter((_, index) => index !== id));
    };
    return (
      <div key={id} className="trailing-item">
        <i
          className="fas fa-trash-alt text-danger"
          style={{ marginRight: 10, fontSize: 13 }}
          onClick={deleteTSL}
        ></i>
        {id + 1}. Set{" "}
        <input
          type="number"
          style={{ width: 50 }}
          value={item.stopAt}
          onChange={(e) => changeStopAt(e.target.value)}
          min={0}
        />
        % {long?"below":"above"} {" "} current price when price hits{" "}
        <input
          type="number"
          style={{ width: 50 }}
          value={item.triggerAt}
          onChange={(e) => changeTriggerAt(e.target.value)}
          min={0}
        />
        % {long?"above":"below"} {long?"Buy":"Sell"} Price
      </div>
    );
  });
  return (
    <div>
      {tslItems}
      {tslItems.length <= 9 && (
        <div>
          <Button onClick={addVariabletSL} variant="success">
            Add
          </Button>
        </div>
      )}
    </div>
  );
};

export default VariableTSL;
